import React, { useState } from "react";
import "./form2.css";
import { useNavigate } from "react-router-dom";

const Form2 = ({ formData, setFormData, setStep }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value.trim() !== "") {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    let newErrors = {};
    console.log(formData);
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "Required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBack = () => {
    setStep(1);
  };

  const HandleNext = (e) => {
    e.preventDefault();
    if (validateForm()) {
      navigate(setStep(3));
    }
  };

  const renderError = (field) =>
    errors[field] ? <span className="error-text">{errors[field]}</span> : null;

  return (
    <>
      <div className="form2-background">
        <div className="form2-section">
          <h2 className="form2-title">Personal Details(2/7)</h2>
          <form>
            <div className="form2-grid">
              <div className="form2-group">
                <label>
                  Profile Category<span className="error fs-star">*</span>
                </label>
                <select
                  name="profileCategory"
                  value={formData.profileCategory}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Farmer, Business">Farmer Business</option>
                  <option value="Government Job">Government Job</option>
                  <option value="Private Job">Private Job</option>
                  <option value="IT Job">IT Job</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Own Business">Own Business</option>
                  <option value="VIP">VIP</option>
                  <option value="VVIP">VVIP</option>
                  <option value="Foreign">Foreign</option>
                </select>

                {renderError("profileCategory")}
              </div>

              <div className="form2-group">
                <label>
                  Education<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="education"
                  placeholder="Enter Your Education"
                  value={formData.education}
                  onChange={handleChange}
                />
                {renderError("education")}
              </div>

              <div className="form2-group">
                <label>
                  Blood Group<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="bloodGroup"
                  placeholder="Enter Your Blood Group"
                  value={formData.bloodGroup}
                  onChange={handleChange}
                />
                {renderError("bloodGroup")}
              </div>
              <div className="form2-group">
                <label>
                  Body Type
                  <span className="error fs-star">*</span>
                </label>
                <select
                  name="BodyType"
                  value={formData.BodyType}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Slim">Slim</option>
                  <option value="Average">Average</option>
                  <option value="Fat">Fat</option>
                  <option value="Fit">Fit</option>
                  <option value="Lean">Lean</option>
                </select>
                {renderError("BodyType")}
              </div>

              <div className="form2-group">
                <label>
                  Job Description<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="jobDescription"
                  placeholder="Enter Your Job Description"
                  value={formData.jobDescription}
                  onChange={handleChange}
                />
                {renderError("jobDescription")}
              </div>

              <div className="form2-group">
                <label>
                  Monthly Income<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="monthlyIncome"
                  placeholder="Enter Your Monthly Income"
                  value={formData.monthlyIncome}
                  onChange={handleChange}
                />
                {renderError("monthlyIncome")}
              </div>

              <div className="form2-group">
                <label>
                  Work Place<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="workPlace"
                  placeholder="Enter Your Work Place"
                  value={formData.workPlace}
                  onChange={handleChange}
                />
                {renderError("workPlace")}
              </div>

              <div className="form2-group">
                <label>
                  Caste<span className="error fs-star">*</span>
                </label>
                <select
                  name="caste"
                  value={formData.caste}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="கொங்கு வெள்ளாள கவுண்டர்">Kongu Vellala Gounder</option>
                  <option value="கொங்கு வேளாளர் உட்பிரிவு">Kongu Vellalar Sub-caste</option>
                  <option value="கொங்கு வேளாளர் கலப்பு">Kongu Vellalar Mixed</option>
                </select>
                {renderError("caste")}
              </div>

              <div className="form2-group">
                <label>
                  kulam<span className="error fs-star">*</span>
                </label>
                <select
                  name="kulam"
                  value={formData.kulam}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="அந்துவன் குலம்">அந்துவன் குலம்</option>
                  <option value="அழகன் குலம்">அழகன் குலம்</option>
                  <option value="ஆட குலம்">ஆட குலம்</option>
                  <option value="ஆதி குலம்">ஆதி குலம்</option>
                  <option value="ஆந்தை குலம்">ஆந்தை குலம்</option>
                  <option value="ஆவ குலம்">ஆவ குலம்</option>
                  <option value="ஆவின் குலம்">ஆவின் குலம்</option>
                  <option value="ஈஞ்சன் குலம்">ஈஞ்சன் குலம்</option>
                  <option value="எண்ணை குலம்">எண்ணை குலம்</option>
                  <option value="ஒழுக்க குலம்">ஒழுக்க குலம்</option>
                  <option value="ஓதாலன் குலம்">ஓதாலன் குலம்</option>
                  <option value="கணக்கன் குலம்">கணக்கன் குலம்</option>
                  <option value="கணவாளன் குலம்">கணவாளன் குலம்</option>
                  <option value="கண்ணந்தை குலம்">கண்ணந்தை குலம்</option>
                  <option value="கண்ணன் குலம்">கண்ணன் குலம்</option>
                  <option value="களிஞ்சி குலம்">களிஞ்சி குலம்</option>
                  <option value="காடை குலம்">காடை குலம்</option>
                  <option value="காரி குலம்">காரி குலம்</option>
                  <option value="கீரன் குலம்">கீரன் குலம்</option>
                  <option value="குயிலர் குலம்">குயிலர் குலம்</option>
                  <option value="குழையர் குலம்">குழையர் குலம்</option>
                  <option value="கூறை குலம்">கூறை குலம்</option>
                  <option value="கோவேந்தர் குலம்">கோவேந்தர் குலம்</option>
                  <option value="சாத்தந்தை குலம்">சாத்தந்தை குலம்</option>
                  <option value="சிலம்பன் குலம்">சிலம்பன் குலம்</option>
                  <option value="செங்கண்ணன் குலம்">செங்கண்ணன் குலம்</option>
                  <option value="செங்குண்ணி குலம்">செங்குண்ணி குலம்</option>
                  <option value="செம்பன் குலம்">செம்பன் குலம்</option>
                  <option value="செம்பூத்தான் குலம்">செம்பூத்தான் குலம்</option>
                  <option value="செல்லன் குலம்">செல்லன் குலம்</option>
                  <option value="செவ்வந்தி குலம்">செவ்வந்தி குலம்</option>
                  <option value="செவ்வாய் குலம்">செவ்வாய் குலம்</option>
                  <option value="சேடன் குலம்">சேடன் குலம்</option>
                  <option value="சேரன் குலம்">சேரன் குலம்</option>
                  <option value="சேரலன் குலம்">சேரலன் குலம்</option>
                  <option value="சோழன் குலம்">சோழன் குலம்</option>
                  <option value="தனஞ்செயன் குலம்">தனஞ்செயன் குலம்</option>
                  <option value="தழிஞ்சி குலம்">தழிஞ்சி குலம்</option>
                  <option value="தூரன் குலம்">தூரன் குலம்</option>
                  <option value="தேவேந்திரன் குலம்">தேவேந்திரன் குலம்</option>
                  <option value="தோடை குலம்">தோடை குலம்</option>
                  <option value="நீருண்ணியர் குலம்">நீருண்ணியர் குலம்</option>
                  <option value="பண்ணை குலம்">பண்ணை குலம்</option>
                  <option value="பதரியர் குலம்">பதரியர் குலம்</option>
                  <option value="பதுமன் குலம்">பதுமன் குலம்</option>
                  <option value="பனங்காடை குலம்">பனங்காடை குலம்</option>
                  <option value="பனையன் குலம்">பனையன் குலம்</option>
                  <option value="பயிரன் குலம்">பயிரன் குலம்</option>
                  <option value="பவழ குலம்">பவழ குலம்</option>
                  <option value="பாண்டியன் குலம்">பாண்டியன் குலம்</option>
                  <option value="பிரழந்தை குலம்">பிரழந்தை குலம்</option>
                  <option value="பில்லன் குலம்">பில்லன் குலம்</option>
                  <option value="பூசன் குலம்">பூசன் குலம்</option>
                  <option value="பூச்சந்தை குலம்">பூச்சந்தை குலம்</option>
                  <option value="பூந்தன் குலம்">பூந்தன் குலம்</option>
                  <option value="பெரிய குலம்">பெரிய குலம்</option>
                  <option value="பெருங்குடி குலம்">பெருங்குடி குலம்</option>
                  <option value="பொடியன் குலம்">பொடியன் குலம்</option>
                  <option value="பொன்னர் குலம்">பொன்னர் குலம்</option>
                  <option value="பொருள்தந்த குலம்">பொருள்தந்த குலம்</option>
                  <option value="மணியன் குலம்">மணியன் குலம்</option>
                  <option value="மயிலர் குலம்">மயிலர் குலம்</option>
                  <option value="மாட குலம்">மாட குலம்</option>
                  <option value="முத்தன் குலம்">முத்தன் குலம்</option>
                  <option value="முல்லை குலம்">முல்லை குலம்</option>
                  <option value="முழுக்காதன் குலம்">முழுக்காதன் குலம்</option>
                  <option value="மூலன் குலம்">மூலன் குலம்</option>
                  <option value="மேதி குலம்">மேதி குலம்</option>
                  <option value="வண்ணக்கன் குலம்">வண்ணக்கன் குலம்</option>
                  <option value="வில்லி குலம்">வில்லி குலம்</option>
                  <option value="விளையன் குலம்">விளையன் குலம்</option>
                  <option value="வெண்டுவன் குலம்">வெண்டுவன் குலம்</option>
                  <option value="வெண்ணை குலம்">வெண்ணை குலம்</option>
                  <option value="வெளியன் குலம்">வெளியன் குலம்</option>
                  <option value="வெள்ளம்பன் குலம்">வெள்ளம்பன் குலம்</option>
                  <option value="வேந்தன் குலம்">வேந்தன் குலம்</option>
                  <option value="கள்ளி குலம்">கள்ளி குலம்</option>
                </select>
                {renderError("kulam")}
              </div>
              <div className="form2-group">
                <label>
                  Kuladeivam<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="kuladeivam"
                  placeholder="Enter Your Kuladeivam"
                  value={formData.kuladeivam}
                  onChange={handleChange}
                />
                {renderError("kuladeivam")}
              </div>

              <div className="form2-group">
                <label>
                  Star<span className="error fs-star">*</span>
                </label>
                <select
                  name="star"
                  value={formData.star}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="அஸ்வினி">Ashwini</option>
                  <option value="பரணி">Bharani</option>
                  <option value="கார்த்திகை">Karthigai</option>
                  <option value="ரோகிணி">Rohini</option>
                  <option value="மிருகசீரிடம்">Mrigaseeridham</option>
                  <option value="திருவாதிரை">Thiruvathirai</option>
                  <option value="புனர்பூசம்">Punarpusam</option>
                  <option value="பூசம்">Poosam</option>
                  <option value="ஆயில்யம்">Ayilyam</option>
                  <option value="மகம்">Magam</option>
                  <option value="பூரம்">Pooram</option>
                  <option value="உத்திரம்">Uthiram</option>
                  <option value="அஸ்தம்">Astham</option>
                  <option value="சித்திரை">Chithirai</option>
                  <option value="சுவாதி">Swathi</option>
                  <option value="விசாகம்">Visakam</option>
                  <option value="அனுஷம்">Anusham</option>
                  <option value="கேட்டை">Kettai</option>
                  <option value="மூலம்">Moolam</option>
                  <option value="பூராடம்">Pooradam</option>
                  <option value="உத்திராடம்">Uthiradam</option>
                  <option value="திருவோணம்">Thiruvonam</option>
                  <option value="அவிட்டம்">Avittam</option>
                  <option value="சதயம்">Sathayam</option>
                  <option value="பூரட்டாதி">Poorattadhi</option>
                  <option value="உத்திரட்டாதி">Uthirattadhi</option>
                  <option value="ரேவதி">Revathi</option>
                </select>
                {renderError("star")}
              </div>

              <div className="form2-group">
                <label>
                  Rasi<span className="error fs-star">*</span>
                </label>
                <select
                  name="rasi"
                  value={formData.rasi}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="மேஷம்">Mesham</option>
                  <option value="ரிஷபம்">Rishabam</option>
                  <option value="மிதுனம்">Mithunam</option>
                  <option value="கடகம்">Kadagam</option>
                  <option value="சிம்மம்">Simmam</option>
                  <option value="கன்னி">Kanni</option>
                  <option value="துலாம்">Thulam</option>
                  <option value="விருச்சிகம்">Viruchigam</option>
                  <option value="தனுசு">Thanusu</option>
                  <option value="மகரம்">Magaram</option>
                  <option value="கும்பம்">Kumbam</option>
                  <option value="மீனம்">Meenam</option>
                </select>
                {renderError("rasi")}
              </div>
              <div className="form2-group">
                <label>
                  password <span className="error fs-star">*</span>
                </label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter Your Password"
                  value={formData.password}
                  onChange={handleChange}
                />
                {renderError("password")}
              </div>

              <div className="form2-group">
                <label>
                  Laknam<span className="error fs-star">*</span>
                </label>
                <select
                  name="laknam"
                  value={formData.laknam}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="மேஷம்">Mesham</option>
                  <option value="ரிஷபம்">Rishabam</option>
                  <option value="மிதுனம்">Mithunam</option>
                  <option value="கடகம்">Kadagam</option>
                  <option value="சிம்மம்">Simmam</option>
                  <option value="கன்னி">Kanni</option>
                  <option value="துலாம்">Thulam</option>
                  <option value="விருச்சிகம்">Viruchigam</option>
                  <option value="தனுசு">Thanusu</option>
                  <option value="மகரம்">Magaram</option>
                  <option value="கும்பம்">Kumbam</option>
                  <option value="மீனம்">Meenam</option>

                </select>
                {renderError("laknam")}
              </div>

              <div className="form2-group">
                <label>
                  Height<span className="error fs-star">*</span>
                </label>
                <select
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {[...Array(171)].map((_, i) => (
                    <option key={i} value={i + 30}>
                      {i + 30} cm
                    </option>
                  ))}
                </select>
                {renderError("height")}
              </div>

              <div className="form2-group">
                <label>
                  Weight<span className="error fs-star">*</span>
                </label>
                <select
                  name="weight"
                  value={formData.weight}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {[...Array(171)].map((_, i) => (
                    <option key={i} value={i + 30}>
                      {i + 30} kg
                    </option>
                  ))}
                </select>
                {renderError("weight")}
              </div>

              <div className="form2-group">
                <label>
                  Colour<span className="error fs-star">*</span>
                </label>
                <select
                  name="colour"
                  value={formData.colour}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Very Fair">Very Fair</option>
                  <option value="Fair">Fair</option>
                  <option value="Wheatish">Wheatish</option>
                  <option value="Wheatish Brown">Wheatish Brown</option>
                  <option value="Dark">Dark</option>
                </select>

                {renderError("colour")}
              </div>

              <div className="form2-group">
                <label>
                  Jathagam<span className="error fs-star">*</span>
                </label>
                <select
                  name="jathagam"
                  value={formData.jathagam}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="சுத்தம் ஜாதகம்">சுத்தம் ஜாதகம்</option>
                  <option value="செவ்வாய் ஜாதகம்">செவ்வாய் ஜாதகம்</option>
                  <option value="சுத்தம் ராகு கேது ஜாதகம்">சுத்தம் ராகு கேது ஜாதகம்</option>
                  <option value="ராகு கேது செவ்வாய் ஜாதகம்">ராகு கேது செவ்வாய் ஜாதகம்</option>
                  <option value="பரிகார செவ்வாய் ஜாதகம்">பரிகார செவ்வாய் ஜாதகம்</option>
                </select>
                {renderError("jathagam")}
              </div>
            </div>

            <div className="form2-btn-group">
              <button type="button" className="back-btn-2" onClick={handleBack}>
                Back
              </button>
              <button
                type="button"
                className="submit-btn-2"
                onClick={HandleNext}
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Form2;
